module.exports = __webpack_public_path__ + "static/media/4.a7ae8243.gif";